export const ROWS_PER_PAGES = [10, 25, 50];
export const HIGHLIGHT_CLASS_NAME = "highlight";
